import { injuryListOutput, TRAINING_ROUTES, } from "@repo/contract/training";
import { profileKeys } from "./keys";
import { readSection, sectionMutation, sectionOptions, writeSection, } from "./section";
/**
 * The body map of injury reports, replaced whole on every `PUT`.
 *
 * Each report may carry a free-text `note` (plan D41), at most 280
 * characters after trimming. It travels with its report and is replaced with
 * it: a `PUT` that omits a note stores that report without one.
 */
const spec = {
    key: profileKeys.injuries,
    name: "injuries",
    output: injuryListOutput,
    path: TRAINING_ROUTES.injuries,
};
/** `GET /me/injuries`. */
export function fetchInjuries(api, init) {
    return readSection(api, spec, init);
}
/** `PUT /me/injuries` — replaces the whole section; answers what is now stored. */
export function putInjuries(api, input) {
    return writeSection(api, spec, input);
}
export function injuriesOptions(api) {
    return sectionOptions(api, spec);
}
export function injuriesMutation(api) {
    return sectionMutation(api, spec);
}
//# sourceMappingURL=injuries.js.map